import React from "react";
import { FormattedMessage } from "react-intl";

import { Icon } from "@sportal/cdk";
import { Button } from "../../button/Button";
import { useIntlTranslate } from "../../../hooks";

export const RefreshRequestsButton = ({ onClick }) => {
  const translate = useIntlTranslate();

  return (
    <Button
      className="devices-control-bar__control"
      size="medium"
      color="secondary"
      onClick={onClick}
      iconRight={<Icon icon="fa-regular fa-sync" />}
      aria-describedby={"refresh_btn"}
    >
      <span id="refresh_btn" className="sr-only" aria-hidden="true">
        {translate("aria_refresh_btn")}
      </span>
      <FormattedMessage id="refresh" />
    </Button>
  );
};
